import { cn } from '@c2fo/liquidity';

export interface NavigationSubItemBaseProps {
  isActive: boolean;
  isDisabled?: boolean;
  animationClassNames: string;
  className?: string;
}

export const getSubItemBaseClassName = ({
  isActive,
  isDisabled,
  animationClassNames,
  className,
}: NavigationSubItemBaseProps) =>
  cn(
    'relative block w-full rounded-2xl p-4 text-left text-sm text-secondary-500',
    {
      'bg-secondary-100': isActive,
      'opacity-50': isDisabled,
    },
    animationClassNames,
    className
  );
